import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { UserService } from './services/user-service.interface';
import { UserServiceImpl } from './services/user-service';
import { UserInfoModel } from './models/user-info-model.interface';
import { UserInfoModelImpl } from './models/user-info-model';
import { UserSettingModel } from './models/user-setting-model.interface';
import { UserSettingModelImpl } from './models/user-setting-model';
import { UserCapacityModel } from './models/user-capacity-model.interface';
import { UserCapacityModelImpl } from './models/user-capacity-model';
import { UserPermissionModel } from './models/user-permission-model.interface';
import { UserPermissionModelImpl } from './models/user-permission-model';
import { UserApi } from './repositories/apis/user-api.interface';
import { UserApiImpl } from './repositories/apis/user-api';
import { UserInfoService } from './services/user-info-service.interface';
import { UserInfoServiceImpl } from './services/user-info-service';
import { UserRepository } from './repositories/user-repository.interface';
import { UserRepositoryImpl } from './repositories/user-repository';
import { UserPermissionService } from './services/user-permission-service.interface';
import { UserPermissionServiceImpl } from './services/user-permission-service';
import { UserSettingService } from './services/user-setting-service.interface';
import { UserSettingServiceImpl } from './services/user-setting-service';
import { UserCapacityService } from './services/user-capacity-service.interface';
export const user = new ContainerModule(bind => {
    bind(UserService).to(UserServiceImpl);
    bind(UserInfoService).to(UserInfoServiceImpl);
    bind(UserPermissionService).to(UserPermissionServiceImpl);
    bind(UserSettingService).to(UserSettingServiceImpl);
    bind(UserCapacityService).to(UserCapacityModelImpl);
    bind(UserInfoModel).to(UserInfoModelImpl);
    bind(UserSettingModel).to(UserSettingModelImpl);
    bind(UserCapacityModel).to(UserCapacityModelImpl);
    bind(UserPermissionModel).to(UserPermissionModelImpl);
    bind(UserRepository).to(UserRepositoryImpl);
    bind(UserApi).to(UserApiImpl);
});
